import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AsyncPaginate } from "react-select-async-paginate";
import { GetEruDetailsPagination, GetEruDetailsPaginationBySearch } from "../../api/User/ACG/ERUsApi";

const SelectAsyncPaginate = (props) => {

  //const [regionName, setRegionName] = useState(null);

  // useEffect(() => {
  //   setRegionName(props.regionName);
  // }, [props.regionName]);

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    const res = await GetEruDetailsPaginationBySearch(page, searchQuery)  
      const responseJSON = await res.data.eruDetails;
      return {
        options: responseJSON,
        hasMore: responseJSON.length >= 1,
        additional: {
          page: searchQuery ? 2 : page + 1
        }
      };
  };

  const onChange = (option) => {
    //props.setCurrentCode(option);
    props.setShowForm(false);
    props.setRxCode(option);
    props.setWitchAction("");
  };

  return (
    <AsyncPaginate
      value={props.value || ""}
      loadOptions={loadOptions}
      getOptionValue={(option) => option.icD10_Code}
      getOptionLabel={(option) => option.icD10_Code}
      onChange={onChange}
      isSearchable={true}
      placeholder="-- Select ICD 10/Rx Code --"
      additional={{
        page: 1
      }}
      styles={props.customStyles}
      menuPlacement="auto"
    />
  );
};

SelectAsyncPaginate.propTypes = {
  regionName: PropTypes.string.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func
};

export default SelectAsyncPaginate;
